<template>
    <div class="newsDetail">
        <div class="title">{{ articleInfo.title }}</div>
        <div class="list acea-row row-middle">
            <div class="item-left">
                <div class="label line1">{{ articleInfo.cart_name }}</div>
                <div class="item">
                    <span class="iconfont"></span>{{ articleInfo.add_time }}
                </div>
            </div>
            <div class="item" v-if="id != 100000">
                <img src="../../../assets/newImg/visit.png" alt="" />{{
                    articleInfo.visit
                }}
            </div>
        </div>
        <template>
        <div class="audio-wrapper" v-if="id != 100000 && url">
            <audio
                ref="audio"
                @pause="onPause"
                @play="onPlay"
                @timeupdate="handleAudioTimeUpdated"
                @loadedmetadata="onLoadedmetadata"
                :src="url"
                controls="controls"
                style="display: none"
            ></audio>

            <div class="audio-right">
                <div class="line l-1 " style="padding:25px 10px 19px 0">
                    {{title}}
                </div>
                <div class="p_slider" @touchstart="handleTouchStart">
                <div class="p_slider_track"></div>
                <div
                    class="p_slider_fill"
                    :style="'width:' + sliderTime + '%'"
                ></div>
                <div
                    class="p_slider_thumb"
                    :style="'left:' + sliderTime + '%'"
                ></div>
            </div>
                <div class="audio-time">
                    <span class="audio-length-current" id="audioCurTime"
                        >{{ audio.currentTime | formatSecond }}</span
                    ><span class="audio-length-total">{{ audio.maxTime | formatSecond }}</span>
                </div>
            </div>
            <div class="audio-left" @click="playaudio">
                <div v-if="audio.playing">
                    <img
                        class="p_img"
                        @click="onPlay()"
                        src="../../../assets/newImg/audio.png"
                        alt=""
                    />
                </div>

                <div v-else>
                    <img
                        class="p_img"
                        @click="onPause()"
                        src="../../../assets/newImg/audio_stop.png"
                        alt=""
                    />
                </div>
            </div>
        </div>
        </template>
        <div class="conter" v-html="articleInfo.content"></div>
        <!-- <div class="picTxt acea-row row-between-wrapper" v-if="storeInfo.id">
      <div class="pictrue"><img :src="storeInfo.image" /></div>
      <div class="text">
        <div class="name line1">{{ storeInfo.store_name }}</div>
        <div class="money font-color-red">
          ￥<span class="num">{{ storeInfo.price }}</span>
        </div>
        <div class="y_money">￥{{ storeInfo.ot_price }}</div>
      </div>
      <router-link :to="{ path: '/detail/' + storeInfo.id }">
        <div class="label"><span class="span">查看商品</span></div>
      </router-link>
    </div>
    <div class="bnt bg-color-red" v-if="isWeixin" @click="setShareInfoStatus">
      和好友一起分享
    </div> -->
        <ShareInfo
            v-on:setShareInfoStatus="setShareInfoStatus"
            :shareInfoStatus="shareInfoStatus"
        ></ShareInfo>
    </div>
</template>
<style scoped>
.newsDetail .picTxt {
    width: 6.9rem;
    height: 2rem !important;
    border-radius: 0.2rem;
    border: 1px solid #e1e1e1;
    position: relative;
    margin: 0.3rem auto 0 auto;
}
.newsDetail .picTxt .pictrue {
    width: 2rem;
    height: 2rem;
}
.newsDetail .picTxt .pictrue img {
    width: 100%;
    height: 100%;
    border-radius: 0.2rem 0 0 0.2rem;
    display: block;
}
.newsDetail .picTxt .text {
    width: 4.6rem;
}
.newsDetail .picTxt .text .name {
    font-size: 0.3rem;
    color: #282828;
}
.newsDetail .picTxt .text .money {
    font-size: 0.24rem;
    margin-top: 0.4rem;
    font-weight: bold;
}
.newsDetail .picTxt .text .money .num {
    font-size: 0.36rem;
}
.newsDetail .picTxt .text .y_money {
    font-size: 0.26rem;
    color: #999;
    text-decoration: line-through;
}
.newsDetail .picTxt .label {
    position: absolute;
    background-color: #303131;
    width: 1.6rem;
    height: 0.5rem;
    right: -0.07rem;
    border-radius: 0.25rem 0 0.06rem 0.25rem;
    text-align: center;
    line-height: 0.5rem;
    bottom: 0.24rem;
}
.newsDetail .picTxt .label .span {
    background-image: linear-gradient(to right, #fff71e 0%, #f9b513 100%);
    background-image: -webkit-linear-gradient(
        to right,
        #fff71e 0%,
        #f9b513 100%
    );
    background-image: -moz-linear-gradient(to right, #fff71e 0%, #f9b513 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}
.newsDetail .picTxt .label:after {
    content: " ";
    position: absolute;
    width: 0;
    height: 0;
    border-bottom: 0.08rem solid #303131;
    border-right: 0.08rem solid transparent;
    top: -0.08rem;
    right: 0;
}
.newsDetail .bnt {
    color: #fff;
    font-size: 0.3rem;
    width: 6.9rem;
    height: 0.9rem;
    border-radius: 0.45rem;
    margin: 0.48rem auto 0 auto;
    text-align: center;
    line-height: 0.9rem;
}
</style>
<script>
// 将整数转换成 时：分：秒的格式
function realFormatSecond(second) {
    var secondType = typeof second;

    if (secondType === "number" || secondType === "string") {
        second = parseInt(second);

        var hours = Math.floor(second / 3600);
        second = second - hours * 3600;
        var mimute = Math.floor(second / 60);
        second = second - mimute * 60;

        return (
            hours +
            ":" +
            ("0" + mimute).slice(-2) +
            ":" +
            ("0" + second).slice(-2)
        );
    } else {
        return "0:00:00";
    }
}
import { getArticleDetails } from "@api/public";
import ShareInfo from "@components/ShareInfo";
import { isWeixin } from "@utils/index";
import { openShareAll } from "@libs/wechat";
import {audioLook} from '@api/user';
export default {
    name: "NewsDetail",
    components: { ShareInfo },
    props: {},
    data: function() {
        return {
            articleInfo: {},
            storeInfo: {},
            shareInfoStatus: false,
            isWeixin: isWeixin(),
            id: "",
            sliderTime: 0, //滑动进度时间
            audio: {
                playing: false, // 该字段是音频是否处于播放状态的属性
                currentTime: 0, // 音频当前播放时长
                maxTime: 0, // 音频最大播放时长
                minTime: 0,
                step: 0.1,
            },
            url:""
        };
    },
    watch: {
        $route(to) {
            if (to.name === "NewsDetail") this.articleDetails();
        },
    },
    mounted: function() {
        if (this.$route.query.token && this.$route.query.token.length > 0) {
            let token = this.$route.query.token
            let time = this.$route.query.expires_time
            const datas = {
                token: token,
                expires_time: time
            };
            this.$store.commit("LOGIN", datas);
        }
        this.articleDetails();
        let audio = document.getElementById("audioPlay");
    },
    methods: {
        updateTitle() {
            document.title = this.articleInfo.title || this.$route.meta.title;
        },
        articleDetails: function() {
            let that = this,
                id = this.$route.params.id;
            getArticleDetails(id).then((res) => {
                that.articleInfo = res.data;
                this.id = id;
                this.title=res.data.audio_name;
                this.url=res.data.audio_url
                that.storeInfo = res.data.store_info || {};
                that.updateTitle();
                if (that.isWeixin) that.share();
            });
        },
        setShareInfoStatus: function() {
            this.shareInfoStatus = !this.shareInfoStatus;
        },
        share: function() {
            openShareAll({
                desc: this.articleInfo.synopsis,
                title: this.articleInfo.title,
                link: location.href,
                imgUrl: this.articleInfo.image_input.length
                    ? this.articleInfo.image_input[0]
                    : "",
            });
        },
        playAudio() {
            var audio = document.getElementById("audio");
            audio.play();
        },
        // 控制音频的播放与暂停
        playaudio() {
            console.log("控制音频的播放与暂停");
            return this.audio.playing ? this.pause() : this.play();
        },
        // 播放音频
        play() {
            this.$refs.audio.play();
        },
        // 暂停音频
        pause() {
            this.$refs.audio.pause();
            console.log("暂停音频");
        },
        // 音频播放
        onPlay() {
            this.audio.playing = true;
            console.log("音频播放");
        },
        // 当音频暂停
        onPause() {
            this.audio.playing = false;
        },
        // 当指定的音频/视频的元数据已加载时，会发生 loadedmetadata 事件。
        onLoadedmetadata(res) {
            console.log("loadedmetadata数据已加载时");
            this.audio.maxTime = parseInt(res.target.duration);
        },
        // 当音频当前时间改变后，进度条也要改变
        handleAudioTimeUpdated(res) {
            console.log("timeupdate");
            // console.log(res.target.currentTime)
            this.audio.currentTime = res.target.currentTime;
            this.sliderTime = parseInt(
                (this.audio.currentTime / this.audio.maxTime) * 100
            );
        },

        // 进度条格式化toolTip
        formatProcessToolTip(index = 0) {
            index = parseInt((this.audio.maxTime / 100) * index);
            return "进度条: " + realFormatSecond(index);
        },
        // touchstart	触摸开始，多点触控，后面的手指同样会触发
        // touchmove	接触点改变，滑动时
        // touchend	触摸结束，手指离开屏幕时
        // touchcancel	触摸被取消，当系统停止跟踪触摸的时候触发
        handleTouchStart(e) {
            console.log(e);
            this.setValue(e.touches[0]);
            document.addEventListener("touchmove", this.handleTouchMove);
            document.addEventListener("touchup", this.handleTouchEnd);
            document.addEventListener("touchend", this.handleTouchEnd);
            document.addEventListener("touchcancel", this.handleTouchEnd);
        },
        handleTouchMove(e) {
            console.log(e.changedTouches[0]);
            this.setValue(e.changedTouches[0]);
        },
        handleTouchEnd(e) {
            this.setValue(e.changedTouches[0]);
            document.removeEventListener("touchmove", this.handleTouchMove);
            document.removeEventListener("touchup", this.handleTouchEnd);
            document.removeEventListener("touchend", this.handleTouchEnd);
            document.removeEventListener("touchcancel", this.handleTouchEnd);
        },
        // 从点击位置更新 value
        setValue(e) {
            // Element.getBoundingClientRect() 方法返回元素的大小及其相对于视口的位置。
            //clientX  点击位置距离当前body可视区域的x，y坐标
            // console.log(e, this.audio, this.$e);
            const $el = this.$el;
            const { maxTime, minTime, step } = this.audio;
            // console.log($el,'$el.offsetWidth')
            let value =
                ((e.clientX - $el.getBoundingClientRect().left) /
                    $el.offsetWidth) *
                (maxTime - minTime);
            value = Math.round(value / step) * step + minTime;
            value = parseFloat(value.toFixed(5));
            if (value > maxTime) {
                value = maxTime;
            } else if (value < minTime) {
                value = minTime;
            }
            this.$refs.audio.currentTime = value;
        },
        // 拖动进度条，改变当前时间，index是进度条改变时的回调函数的参数0-100之间，需要换算成实际时间
        changeCurrentTime(index) {
            console.log("拖动进度条");
            // console.log('拖动了',index,this.sliderTime,this.audio.maxTime,parseInt(index / 100 * this.audio.maxTime))
            this.$refs.audio.currentTime = parseInt(
                (index / 100) * this.audio.maxTime
            );
        },
    },
    filters: {
        // 将整数转化成时分秒
        formatSecond(second = 0) {
            return realFormatSecond(second);
        },
    },
};
</script>
<style scoped>
.newsDetail .list .item img {
    width: 20px;
    height: 20px;
}
.newsDetail .list .item {
    display: flex;
    align-items: center;
}
.item-left {
    display: flex;
    align-items: center;
}
.newsDetail .list {
    display: flex;
    justify-content: space-between;
}

.audio-wrapper {
    height: 110px;
    background: #f7f7f7;
    border-radius: 10px;
    margin: 10px;
    display: flex;
    justify-content: space-between;
}
audio {
    margin-left: 19px;
}
.audio-left {
    float: left;
    text-align: center;
    width: 18%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.audio-left img {
    width: 40px;
    position: relative;
    top: 15px;
    margin: 0;
    display: initial; /* 解除与app的样式冲突 */
    cursor: pointer;
}

.audio-right {
    float: right;
    width: 75%;
    height: 100%;
    padding-left: 19px;
}

.audio-right p {
    font-size: 15px;
    height: 35%;
    margin: 8px 0;

    /* 歌曲名称只显示在一行，超出部分显示为省略号 */
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 243px; /* 要适配小屏幕手机，所以最大宽度先设小一点，后面js根据屏幕大小重新设置 */
}

.progress-bar-bg {
    background-color: #d9d9d9;
    position: relative;
    height: 2px;
    cursor: pointer;
}

.progress-bar {
    background-color: #649fec;
    width: 0;
    height: 2px;
}

.progress-bar-bg span {
    content: " ";
    width: 10px;
    height: 10px;
    border-radius: 50%;
    -moz-border-radius: 50%;
    -webkit-border-radius: 50%;
    background-color: #3e87e8;
    position: absolute;
    left: 0;
    top: 50%;
    margin-top: -5px;
    margin-left: -5px;
    cursor: pointer;
}

.audio-time {
    overflow: hidden;
    margin-top: -1px;
}

.audio-length-total {
    float: right;
    font-size: 12px;
}

.audio-length-current {
    float: left;
    font-size: 12px;
}
</style>

<style lang="scss" scoped>
.p_cotrol {
    margin: 0 auto;
    display: flex;
    width: 90%;
    padding: 20px;
    background-color: #fff;
    .p_img {
        width: 30px;
        height: 30px;
    }
    .p_time {
        font-size: 14px;
        line-height: 30px;
        margin: 0 10px;
    }


}
    // 进度条
    .p_slider {
        width: 100%;
        position: relative;
        height: 24px;
        display: flex;
        align-items: center;
        cursor: default;
        user-select: none;
        outline: none;
    }

    .p_slider_track {
        position: absolute;
        height: 2px;
        left: 0;
        right: 0;
        top: 50%;
        margin-top: -1px;
        background-color: #cccccc;
    }

    .p_slider_fill {
        position: absolute;
        height: 2px;
        width: 100%;
        background-color: #ffcd3a;
        left: 0;
        top: 50%;
        margin-top: -1px;
    }

    .p_slider_thumb {
        position: absolute;
        top: 50%;
        width: 12px;
        height: 12px;
        background-color: #ffcd3a;
        color: #ffcd3a;
        border-radius: 50%;
        transform: translate(-50%, -50%);
        cursor: pointer;
    }
</style>
